export const getOrdinal = number => {
    const thisOrdinal = letters => `${number}${letters}`;
    if ([11, 12, 13].includes(number)) {
        return thisOrdinal("th");
    }

    const lastDigit = number.toString()[number.toString().length - 1];
    switch (lastDigit) {
        case "1":
            return thisOrdinal("st");
        case "2":
            return thisOrdinal("nd");
        case "3":
            return thisOrdinal("rd");
        default:
            return thisOrdinal("th");
    }
};



// WEBPACK FOOTER //
// ./src/getOrdinal.js